import Vue from 'vue'

import IOTDevice from './IOTDevice.js'

export default class VideonDecoder extends IOTDevice {
  constructor(device_guid, device_attributes = false) {
    super(device_guid, device_attributes)
    
    this.device_type = 'decoder'
    
    // device specific things
    this.shadowDocuments = ['Inputs']
    
    
    // data fetching
    if (!this.state) {
      setTimeout(() => {
        this.fetchState()
      }, 1)
    }
    
    setTimeout(() => {
      this.fetchLicenses()
    }, Vue.helpers.getRefreshInterval(1, 10))
    
    setTimeout(() => {
      this.syncDocuments()
    }, Vue.helpers.getRefreshInterval(50, 100))
    
    setTimeout(() => {
      this.fetchMetadata()
    }, Vue.helpers.getRefreshInterval(50, 100))
  }
  
  icon() {
    return '$birddog'
  }
  
  deviceName(refresh = false) {
    if (this.device_name && !refresh) {
      return this.device_name
    }
    
    if (this.metadata && this.hasMetadataKey('device_alias')) {
      this.device_name = Vue.helpers.htmlDecode(this.metadataValue('device_alias'))
      return this.device_name
    }
    
    if (this.state && this.state.decoder_info && this.state.decoder_info.HostName) {
      this.device_name = this.state.decoder_info.HostName
      return this.device_name
    }
    
    this.device_name = this.serial_number + ' [' + this.mac_address + ']'
    return this.device_name
  }
  
  deviceIP(refresh = false) {
    if (this.device_ip && !refresh) {
      return this.device_ip
    }
    
    if (this.state) {
      if (this.state.decoder_info && this.state.decoder_info.IPAddress) {
        this.device_ip = this.state.decoder_info.IPAddress
      }
      if (this.state.external_ip) {
        this.external_ip = this.state.external_ip
      }
    }
    
    return this.device_ip
  }
  
  IPScheme(refresh = false) {
    if (this.ip_scheme && !refresh) {
      return this.ip_scheme
    }
    
    if (this.state && this.state.decoder_info && this.state.decoder_info.NetworkConfigMethod) {
      this.ip_scheme = this.state.decoder_info.NetworkConfigMethod
      return this.ip_scheme
    }
    
    return false
  }
}